<router-outlet></router-outlet>
<sq-notifications></sq-notifications>

<!-- <ng-template #popTemplate id="commentPopover">
    <div style="max-height: 6em;overflow: auto;" id="divPopover">
    </div>
  <a href="https://i-am-souravdutta.firebaseapp.com/" target="_blank">Open my webpage</a> 
</ng-template>
<span  style="display:inline-block" [stickyPopover]="popTemplate" placement="auto" triggers="manual">
  <i class="icon">Hover over me!</i>
</span>  -->